import { action } from 'sky-engine/api/index'

import { LIMIT } from '@/api/apiModules'

/**
 * 点赞
 * @returns
 */
export function doLike(params) {
  return action(LIMIT, 'doLike', params)
}

/**
 * 点踩
 * @returns
 */
export function doDislike(params) {
  return action(LIMIT, 'doDislike', params)
}
